import { render, staticRenderFns } from "./WhitelabelConfig.vue?vue&type=template&id=e7dea6b2&scoped=true&"
import script from "./WhitelabelConfig.vue?vue&type=script&lang=js&"
export * from "./WhitelabelConfig.vue?vue&type=script&lang=js&"
import style0 from "./WhitelabelConfig.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WhitelabelConfig.vue?vue&type=style&index=1&id=e7dea6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7dea6b2",
  null
  
)

export default component.exports